import { updateUser, getUsers } from "../api/userService";

export const useUpdateUser = (setUsers) => {
    const update = async (id, data) => {
        try {
            const updatedUser = await updateUser(id, data);
            const usersResponse = await getUsers();
            setUsers(usersResponse);
            return updatedUser;
        } catch (error) {
            console.error("Failed to update user:", error);
            throw error;
        }
    };

  return { update };
};